export default "__VITE_ASSET__oTr_n0hE__"